export default __webpack_public_path__ + "static/media/video-call.a365cf2d.gif";